//Регистратор сервисов в редаксе

/**Регистрация АПИ*/
export const setApi = (Api) => {
  //имя переменной service.Api
  return {type: 'SET_SERVICE_API', payload:Api};
};
/**Регистрация Сервиса Пользователя*/
export const setUser = (User) => {
  //имя переменной service.Api
  return {type: 'SET_SERVICE_USER', payload:User};
};
//
/**Регистрация Сервиса Справочников*/
export const setDirectory = (Directory) => {
  //имя переменной service.Api
  return {type: 'SET_SERVICE_DIRECTORY', payload:Directory};
};
/**Регистрация Сервиса Маршрутов*/
export const setRoute = (Route) => {
  //имя переменной service.Api
  return {type: 'SET_SERVICE_ROUTE', payload:Route};
};
/**Регистрация Сервиса Геозон*/
export const setGeozone = (Geozone) => {
  //имя переменной service.Api
  return {type: 'SET_SERVICE_GEOZONE', payload:Geozone};
};
